export default "__VITE_ASSET__CWeczo2m__"